<div class="login-container">
  <div class="d-flex d-md-none login-head">
    <span>{{'LOGIN.influencer_program' | translate}}</span>
  </div>
  <form class="login-form" novalidate (ngSubmit)="onSubmit(user)" [formGroup]="user">
    <p class="advertise-error-link" *ngIf="isLoggedInWithAdvertiserAccount">
      <span class="error" [innerHTML]="'LOGIN.login_with_advertiser_account' | translate"></span>
    </p>
    <input required formControlName="username"
           id="login-username"
           name="username"
           type="email"
           class="form-control"
           placeholder="Email"
           email />

    <input required
           formControlName="password"
           id="login-password"
           name="password"
           type="password"
           class="form-control last-field"
           placeholder="Password" />

    <p class="forgot-password-note"><a class="forgot-password">{{'LOGIN.forgot_password' | translate}}</a></p>
    <button class="btn btn-default btn-login"
            id="login-submit"
            type="submit"
            [disabled]="user.invalid">{{'LOGIN.sign_in' | translate}}</button>

    <button class="btn btn-default"
            id="facebook-login-submit"
            type="button" (click)="signInWithFacebook()">
      <img src="./assets/images/Facebook_Login_Icon.svg" alt="">
      {{'LOGIN.facebook_login_btn' | translate}}
    </button>

    <div class="login-error flex-column flex-wrap" *ngIf="hasFbAuthError">
      <span class="error">
        {{"fb_auth.error.invalid_influencer" | translate}}
        <a class="error underline-link" [routerLink]="'influencer/login'">{{"fb_auth.error.click_here" | translate}}</a>
        {{"fb_auth.error.go_back_to_login" | translate}}
      </span>
    </div>

    <div class="login-error flex-column flex-wrap" *ngIf="hasMissingPermissionError">
      <span class="error">
        {{"fb_auth.error.missing_permission.part_1" | translate}}
        <a class="error underline-link" [attr.href]="'https://www.facebook.com/settings?tab=business_tools&ref=settings'">{{"fb_auth.error.missing_permission.fb_settings_page" | translate}}</a>
        {{"fb_auth.error.missing_permission.part_2" | translate}}
      </span>
    </div>

    <div class="login-error" *ngIf="hasNoBusinessAccountError">
      <div class="error no-business-account">
        <div class="first-part"><span>{{"fb_auth.error.no_business_account.part_1" | translate}}</span></div>
        <span>
          {{"fb_auth.error.no_business_account.part_2" | translate}}
          <a class="error underline-link" [attr.href]="'https://www.facebook.com/settings?tab=business_tools&ref=settings'">{{"fb_auth.error.no_business_account.fb_settings_page" | translate}}</a>
          {{"fb_auth.error.no_business_account.part_3" | translate}}
        </span>
      </div>
    </div>

    <div class="login-error" *ngIf="hasFacebookGeneralPermissionError">
      <span class="error">{{"fb_auth.error.general_facebook_permission" | translate}}</span>
    </div>

    <div class="login-error" *ngIf="hasError && !hasErrorSelectUser && !hasNoBusinessAccountError && !hasFbAuthError && !hasMissingPermissionError && !hasFacebookGeneralPermissionError">
      <span class="error">{{"fb_auth.error.auth_fail" | translate}}</span>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-login/influencer-login.component.html